export const supportedLanguagesArray = ['hu', 'en'];

export type SupportedLanguage = (typeof supportedLanguagesArray)[number];
